import { indicatorHasValue } from "./indicator-has-value";
export var indicatorsWithResults = function (items) {
  return items.filter(indicatorHasValue);
};